import React from 'react';

import { PageTitle } from '../../../components';
import { ScheduleTab } from '../../../sections';



const ScheduleTabPage = () => {

  return (
    <>

      {/* Page Title */}
      <PageTitle title={'Schedule Tab'} page={'Schedule Tab'} />

      {/* Schedule tab section */}
      <ScheduleTab />

    </>
  );
};

export default ScheduleTabPage;